import React, { useState, useEffect } from "react";
import { Layout, Menu, message, Modal } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  DashboardOutlined,
  CalendarOutlined,
  UserAddOutlined,
  UnorderedListOutlined,
  ScheduleOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import logo from "../../Assests/Images/logo.svg";
import profilePic from "../../Assests/Images/profile.svg";
import profile from "../../Assests/Images/prodileDp.png";
import logoutIcon from "../../Assests/Images/logout.svg";
import "./style.css";

const { Sider } = Layout;

const Sidebar = ({ collapsed, setCollapsed, breakpoint, user, setUser }) => {
  const location = useLocation();
  const [selectedId, setSelectedId] = useState("1");
  const navigate = useNavigate();
  const [logoutModalVisible, setLogoutModalVisible] = useState(false);
  const [isCollapsedBreakpoint, setIsCollapsedBreakpoint] = useState(false);

  useEffect(() => {
    const path = location.pathname;
    if (path.includes("/overview")) setSelectedId("1");
    else if (path.includes("/event-calendar")) setSelectedId("2");
    else if (path.includes("/add-client")) setSelectedId("3");
    else if (path.includes("/client-list")) setSelectedId("4");
    else if (path.includes("/event")) setSelectedId("5");
  }, [location.pathname]);

  const items = [
    {
      key: "1",
      icon: <DashboardOutlined />,
      label: <Link to="/overview">Overview</Link>,
    },
    {
      key: "2",
      icon: <CalendarOutlined />,
      label: <Link to="/event-calendar">Event Calendar</Link>,
    },
    {
      key: "3",
      icon: <UserAddOutlined />,
      label: <Link to="/add-client">Add Client</Link>,
    },
    {
      key: "4",
      icon: <UnorderedListOutlined />,
      label: <Link to="/client-list">Client List</Link>,
    },
    {
      key: "5",
      icon: <ScheduleOutlined />,
      label: <Link to="/event">Events</Link>,
    },
  ];

  const handleMenuItemClick = () => {
    if (isCollapsedBreakpoint) {
      setCollapsed(true);
    }
  };

  const handleLogoutClick = () => {
    if (isCollapsedBreakpoint) {
      setCollapsed(true);
    }
    setLogoutModalVisible(true);
  };

  return (
    <Sider
      className="sidebar"
      width={276}
      collapsible
      collapsed={collapsed}
      onCollapse={(val) => setCollapsed(val)}
      collapsedWidth={0}
      breakpoint="lg"
      onBreakpoint={(broken) => setIsCollapsedBreakpoint(broken)}
      theme="light"
      style={{ height: "100vh", position: "fixed" }}
    >
      <div className="logo-container">
        <img src={logo} alt="logo" style={{ width: "100px", padding: "5px" }} />
      </div>

      <div className="sidebar-divider"></div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "calc(100% - 80px)",
        }}
      >
        <div style={{ flex: 1, overflowY: "auto" }}>
          <Menu
            mode="inline"
            theme="light"
            selectedKeys={[selectedId]}
            items={items}
            onClick={handleMenuItemClick}
          />
        </div>

        <div
          className="logout-div"
          onClick={handleLogoutClick}
          style={{ cursor: "pointer" }}
        >
          <div className="logout-user">
            <div className="compact-avatar">
              <img
                className="profile-pic"
                src={profile}
                width={40}
                alt="user-icon"
              />
            </div>
            <div className="logout-user-details">
              <div className="name">{user?.name}</div>
              <span className="position">{user?.email}</span>
            </div>
          </div>
        </div>

        <div className="logout-icon">
          <Modal
            className="logout-modal"
            open={logoutModalVisible}
            title={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "24px",
                }}
              >
                <img
                  src={logoutIcon}
                  alt="logout"
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: 8,
                    backgroundColor: "#FFEA9F",
                  }}
                />
                <div className="logout-text">
                  <span>Log out?</span>
                  <p>Are you sure you want to log out?</p>
                </div>
              </div>
            }
            okText="Sure"
            cancelText="Cancel"
            centered
            onOk={() => {
              message.success("Logged out successfully");
              setUser("public");
              navigate("/login");
              setLogoutModalVisible(false);
              localStorage.clear();
            }}
            onCancel={() => setLogoutModalVisible(false)}
          />
        </div>
      </div>
    </Sider>
  );
};

export default Sidebar;
